import { render, staticRenderFns } from "./detailField.vue?vue&type=template&id=9aa88b74&"
import script from "./detailField.vue?vue&type=script&lang=js&"
export * from "./detailField.vue?vue&type=script&lang=js&"
import style0 from "./detailField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "detailField.vue"
export default component.exports